<template>
  <div v-if="events && events.length">
    <AthleteSectionSubheading>Events</AthleteSectionSubheading>
    <table
      class="w-full mb-8 overflow-hidden bg-white rounded shadow"
      border="1"
      frame="void"
      rules="rows"
    >
      <thead
        class="ds-text-base text-transparent font-bold uppercase bg-blue-500 text-left border-none"
      >
        <th class="hidden px-4 py-3 md:table-cell">
          <span class="text-white">Name Of Event</span>
        </th>
        <th class="hidden px-4 py-3 md:table-cell">
          <span class="text-white">date</span>
        </th>
        <th class="hidden px-4 py-3 md:table-cell">
          <span class="text-white">location</span>
        </th>
        <th class="hidden md:table-cell"></th>
        <th class="relative px-4 py-3 flex justify-end md:table-cell">
          <Dropdown
            @toggle="toggleDropdown"
            dropdownContentAlign="right"
            ref="dropdown"
            :style="{marginLeft: 'initial'}"
          >
            <div slot="toggle">
              <a
                href="#"
                @click.prevent
                class="ds-text-base text-white no-underline flex flex-row items-center"
              >
                {{selectedEventFilter}}
                <i class="sr-2 sr-v2-chevron pl-1"></i>
              </a>
            </div>
            <div slot="content">
              <DropdownActionItem @click="select('all')">
                <p class="font-normal normal-case text-gray-1000">All</p>
              </DropdownActionItem>
              <DropdownActionItem @click="select('upcoming')">
                <p class="font-normal normal-case text-gray-1000">Upcoming</p>
              </DropdownActionItem>
              <DropdownActionItem @click="select('past')">
                <p class="font-normal normal-case text-gray-1000">Past</p>
              </DropdownActionItem>
            </div>
          </Dropdown>
        </th>
      </thead>
      <tbody v-if="paginatedEventsToRender && paginatedEventsToRender.length">
        <EventsRow
          v-for="(event, index) in paginatedEventsToRender"
          :key="event.id"
          :data-index="index"
          :event="event"
        />
      </tbody>

      <tbody v-else>
        <tr
          class="ds-text-base font-medium text-gray-900 border-0 border-t-0 border-b border-gray-200 border-solid"
        >
          <td class="px-4 py-3 text-center" colspan="4">
            This athlete has no
            <span
              v-if="selectedEventFilter != 'all'"
            >{{selectedEventFilter}}&nbsp;</span>events
          </td>
        </tr>
      </tbody>

      <tr class v-if="canShowMore">
        <td colspan="5" class="px-4 py-2 text-right">
          <a href="#" class="ds-text-base" @click.prevent="showMoreEvents">Show more</a>
        </td>
      </tr>
      <tr v-else-if="!canShowMore && eventsToShow > 5">
        <td colspan="5" class="px-4 py-2 text-right">
          <a href="#" class="ds-text-base" @click.prevent="showLessEvents">Show Less</a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AthleteSectionSubheading from "../../AthleteSectionSubheading.vue";
import EventsRow from "./AthleteEventsRow.vue";
import {Dropdown, DropdownActionItem} from '@sportsrecruits/playbook';

export default {
  components: {
    AthleteSectionSubheading,
    Dropdown,
    DropdownActionItem,
    EventsRow
  },
  props: {
    userId: { required: true }
  },
  data() {
    return {
      eventsToShow: 5,
      isOpen: false,
      selectedEventFilter: "all"
    };
  },
  mounted() {
    this.$store.dispatch("athleteProfile/fetchEvents", this.userId).then(() => {
      const currentDate = new Date();
      for (event of this.events) {
        const startDate = new Date(event.startDate);
        const endDate = new Date(event.endDate);
        endDate.setDate(endDate.getDate() + 1);
        if (this.isValidDate(startDate) && (startDate > currentDate || (this.isValidDate(endDate) && endDate > currentDate))) {
          this.select("upcoming");
        }
      }
    });
  },
  methods: {
    toggleDropdown(newIsOpenValue) {
      const wasOpen = this.isOpen;
      this.isOpen = newIsOpenValue;
    },
    showMoreEvents() {
      this.eventsToShow += 5;
    },
    showLessEvents() {
      this.eventsToShow = 5;
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    },
    select(type) {
      this.eventsToShow = 5;
      this.selectedEventFilter = type;
      this.$refs.dropdown.close();
    },
    getFormattedDate(dateString) {
      if (!dateString) {
        return null;
      }
      let date = dateString.split("T")[0];
      let [year, month, day] = date.split("-");
      return month + "/" + day + "/" + year;
    },
    datesAreOnSameDay(first, second) {
      return first.getFullYear() === second.getFullYear() &&
          first.getMonth() === second.getMonth() &&
          first.getDate() === second.getDate();
    }
  },
  computed: {
    ...mapGetters("athleteProfile", {
      events: "events",
      userSport: "sport"
    }),
    ...mapGetters("userData", ["isCollegeCoach", "relevantGender", "sport"]),

    allSelectedEvents: function() {
      const currentDate = new Date();
      return this.events.filter(event => {
        const startDate = new Date(event.startDate);
        const endDate = new Date(event.endDate);
        endDate.setDate(endDate.getDate() + 1);
        switch (this.selectedEventFilter) {
          case "all":
            return true;
            break;
          case "upcoming":
            return this.isValidDate(startDate) && (startDate > currentDate || (this.isValidDate(endDate) && endDate > currentDate));
            return;
            break;
          case "past":
            if (this.isValidDate(endDate)) {
              return endDate < currentDate;
            } else {
              return this.isValidDate(startDate) && (startDate < currentDate);
            }
            break;
        }


      });
    },
    paginatedEventsToRender: function () {
      switch (this.selectedEventFilter) {
        case "upcoming":
          return this.allSelectedEvents
              .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
              .slice(0, this.eventsToShow);
          break;
        default:
          return this.allSelectedEvents
              .sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
              .slice(0, this.eventsToShow)
      }

    },
    canShowMore: function() {
      return this.eventsToShow < this.allSelectedEvents.length;
    }
  }
};
</script>

<style scoped>
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.height-0 {
  height: 0px;
}
.tr-height {
  max-height: 100px;
}
@keyframes grow-height {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.cs-animation-ease-in {
  animation: grow-height 0.5s ease-out;
}
</style>